import React, { Component, Fragment } from "react";
import {
  FieldGroup,
  FieldControl,
  Validators,
  FormBuilder
} from "react-reactive-form";
import { Link } from "react-router-dom";
import { Auth } from "aws-amplify";
import PropTypes from "proptypes";
import {
  passwordValidator,
  readableResponseMessage
} from "ux-helpers";
import "../../lib/forms/Forms.scss";
import 'react-phone-number-input/style.css';
import PhoneInput from 'react-phone-number-input';
// import { isValidPhoneNumber } from 'react-phone-number-input'

export default class SignUp extends Component {
  state = {
    message: "",
    phoneNumberError: true
  };

  componentDidMount() {
    window.scrollTo({
      top: 400,
      behavior: 'smooth',
    })

    // Could use text-transform: lowercase in CSS and toLowerCase once the user submits the form.
    const emailFieldControl = this.signUpForm.get("emailAddress");

    emailFieldControl.onValueChanges.subscribe(
      value => {
        emailFieldControl.setValue(value.toLowerCase());
      }
    );
  }

  handleSubmit = (e, formVals) => {
    e.preventDefault();
    this.signUp(formVals);
  }

  signUp = async form => {
    if (this.signUpForm.status === "VALID") {
      const nickName = `${form.firstName} ${form.lastName}`;
      this.setState({ loadingBtn: true });
      this.signUpForm.handleSubmit();

      // if (!isValidPhoneNumber(this.state.phone)) {
      //   this.setState({
      //     message: "Please double-check your phone number."
      //   });
      //   this.setState({ loadingBtn: false });
      //   return false;
      // }

      Auth.signUp({
        username: form.emailAddress.toLowerCase(),
        password: form.password,
        attributes: {
          email: form.emailAddress.toLowerCase(),
          // phone_number: this.state.phone,
          "custom:provided_phone": this.state.phone,
          given_name: form.firstName,
          family_name: form.lastName,
          nickname: nickName
        }
      })
        .then(() => {
          const userProps = {
            emailAddress: form.emailAddress,
            password: form.password,
            phoneNumber: this.state.phone,
            mobilePhoneNumber: this.state.phone,
            name: `${form.firstName} ${form.lastName}`,
            firstName: form.firstName,
            lastName: form.lastName
          };
          this.props.setParentState("userProps", userProps);
          this.props.history.push("/verify-account");
        })
        .catch(error => {
          this.setState({
            loadingBtn: false,
            message: readableResponseMessage(error)
          });
          this.signUpForm.handleSubmit();
          if (
            error.message === "An account with the given email already exists."
          ) {
            this.setState({
              message:
                "An account with the given email already exists, sending you to sign-in."
            });
            setTimeout(() => {
              this.props.history.push("/");
            }, 3000);
          }
        });
    } else {
      this.signUpForm.handleSubmit();
    }
  };

  passwordMatchValidator = () => {
    if (
      this.signUpForm.controls["password"].value !==
      this.signUpForm.controls["confirmPassword"].value
    ) {
      this.signUpForm.controls["confirmPassword"].errors = { mismatch: true };
    }
  };

  signUpForm = FormBuilder.group({
    firstName: ["", Validators.required],
    lastName: ["", Validators.required],
    emailAddress: ["", [Validators.required, Validators.email]],
    password: ["", [Validators.required, passwordValidator]],
    confirmPassword: ["", Validators.required]
  });

  render() {
    this.signUpForm.controls["confirmPassword"].valueChanges.subscribe(() => {
      if (this.signUpForm.controls["confirmPassword"].value !== "") {
        this.passwordMatchValidator();
      }
    });
    return (
      <div className="row center justify-content-center">
        <div className="col-md-6 col-sm-12">
          <h2>Create Your Account</h2>
          <p>
            If you&apos;ve already applied to be a GIVE volunteer,{" "}
            <span className="brand-primary">
              please use the same email address you applied with
            </span>
            . If you haven&apos;t applied, that&apos;s okay! Please create an
            account below, and complete the application form, after validating
            your email address.
          </p>
          {this.state.message ? (
            <p className="error">{this.state.message}</p>
          ) : (
            ""
          )}
          <Fragment>
            <FieldGroup
              control={this.signUpForm}
              render={({ submitted, value }) => (
                <form
                  name="Create Account"
                  id="signup-form"
                  onSubmit={e => this.handleSubmit(e, value)}
                  autoComplete="off"
                >
                  <div className="row">
                    <div className="col-md-6 col-sm-12">
                      <FieldControl
                        name="firstName"
                        render={({ handler, touched, hasError, pristine }) => (
                          <div className="inputContainer">
                            <input
                              name="firstName"
                              className="form-control"
                              type="text"
                              {...handler()}
                            />
                            <label
                              htmlFor="firstName"
                              className={`label ${pristine ? "" : "notEmpty"}`}
                            >
                              First Name
                              <span className="error">
                                {(touched || submitted) &&
                                  hasError("required") &&
                                  " - Required"}
                              </span>
                            </label>
                          </div>
                          )}
                        />
                    </div>
                    <div className="col-md-6 col-sm-12">
                      <FieldControl
                        name="lastName"
                        render={({ handler, touched, hasError, pristine }) => (
                          <div className="inputContainer">
                            <input
                              name="lastName"
                              className="form-control"
                              type="text"
                              {...handler()}
                            />
                            <label
                              htmlFor="lastName"
                              className={`label ${pristine ? "" : "notEmpty"}`}
                            >
                              Last Name
                              <span className="error">
                                {(touched || submitted) &&
                                  hasError("required") &&
                                  " - Required"}
                              </span>
                            </label>
                          </div>
                        )}
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12">
                      <FieldControl
                        name="emailAddress"
                        render={({ handler, touched, hasError, pristine }) => (
                          <div className="inputContainer">
                            <input
                              name="emailAddress"
                              className="form-control"
                              type="text"
                              {...handler()}
                            />
                            <label
                              htmlFor="emailAddress"
                              className={`label ${pristine ? "" : "notEmpty"}`}
                            >
                              Email Address
                              <span className="error">
                                {(touched || submitted) &&
                                  hasError("required") &&
                                  " - Required"}
                                {(touched || submitted) &&
                                  hasError("email") &&
                                  " - Not a valid Email"}
                              </span>
                            </label>
                          </div>
                        )}
                      />
                      <FieldControl
                        name="password"
                        render={({ handler, touched, hasError, pristine }) => (
                          <div className="inputContainer">
                            <input
                              name="password"
                              className="form-control"
                              type="password"
                              {...handler()}
                            />
                            <label
                              htmlFor="password"
                              className={`label ${pristine ? "" : "notEmpty"}`}
                            >
                              Password
                              <span className="error">
                                {((touched || submitted) &&
                                  (hasError("required") && " - Required")) ||
                                  (touched &&
                                    hasError("password") && (
                                      <span className="bubble-error-message">
                                        Must be 8 characters and include at least
                                        one uppercase letter, lowercase letter,
                                        special character (~!@#$%^&*?), and number
                                      </span>
                                    ))}
                              </span>
                            </label>
                          </div>
                        )}
                      />
                      <FieldControl
                        name="confirmPassword"
                        render={({ handler, touched, hasError, pristine }) => (
                          <div className="inputContainer">
                            <input
                              name="confirmPassword"
                              className="form-control"
                              type="password"
                              {...handler()}
                            />
                            <label
                              htmlFor="confirmPassword"
                              className={`label ${pristine ? "" : "notEmpty"}`}
                            >
                              Confirm Password
                              <span className="error">
                                {((touched || submitted) &&
                                  (hasError("required") && " - Required")) ||
                                  ((touched || submitted) &&
                                    hasError("mismatch") &&
                                    " - Password doesn't match")}
                              </span>
                            </label>
                          </div>
                        )}
                      />
                      <PhoneInput
                        placeholder="Mobile Phone Number"
                        value={ this.state.phone }
                        country="US"
                        defaultCountry="US"
                        onChange={ phone => this.setState({ phone }) } />
                      <br/>
                      <button
                        className={`${
                          this.state.loadingBtn ? "btn-text-hide" : ""
                        }`}
                        type="submit"
                        disabled={this.state.loadingBtn}
                        >
                        Submit
                        <span
                          className={`${this.state.loadingBtn ? "loader" : ""}`}
                        />
                      </button>
                    </div>
                  </div>
                </form>
              )}
            />
            <p>
              Back to <Link to="/"> Sign In </Link>
            </p>
          </Fragment>
        </div>
      </div>
    );
  }
}

SignUp.propTypes = {
  handleRouting: PropTypes.func.isRequired,
  setParentState: PropTypes.func.isRequired
};
